import { combineReducers } from "redux";
import UserReducer from "../slices/users/reducer";
import UserAuthSlic from "../slices/auth/login/reducer"
import categorySlice from "../slices/category/reducer"
import UserContestSlice from "../slices/contest/reducer"
import CommentReducer from "../slices/comments/reducer"
import userRequest from "../slices/user-requests/reducer"
import NotificationsSlice from "../slices/notifications/reducer"
import RewardsSlice from "../slices/rewards/reducer"
import EventSlice from "../slices/events/reducer";


const rootReducer = combineReducers({

  user: UserReducer,
  event: EventSlice,
  auth: UserAuthSlic,
  category:categorySlice,
  contest:UserContestSlice,
  comments:CommentReducer,
  userRequest:userRequest,
  notifications:NotificationsSlice,
  rewards:RewardsSlice
 
});

export default rootReducer;
